import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
import { objections } from '../data/content';
export function Objections() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section title="Lo que probablemente piensas" tone="deep" data-id="element-67" data-mp="hle9199m0vam">
      <ul className="divide-y divide-ink-line border-y border-ink-line" data-id="element-68" data-mp="hn8r8fthy9b0">
        {objections.map((objection, index) => {
        const isOpen = openIndex === index;
        return <li key={objection.question} data-id="element-69" data-mp="7sypi7inzynm" data-mpi={index}>
              <h3 data-id="element-70" data-mp="3sy7kcwcx5bt">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-6 text-left transition-colors duration-150 ease-smooth hover:text-terracotta focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink" data-id="element-71" data-mp="3uj242io8o9o">
                  <span className="text-xl font-semibold text-inherit md:text-2xl" data-id="element-72" data-mp="ffpf9zgdzx0">
                    “{objection.question}”
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-terracotta transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-73" data-mp="3mogx5fdye4v8" />
                </button>
              </h3>

              <AnimatePresence initial={false} data-id="element-74" data-mp="o6uw1ey9j3e2">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-75" data-mp="99kjs3dsptha">
                    <div className="space-y-1.5 pb-7 pr-10 text-lg leading-relaxed text-ink-soft" data-id="element-76" data-mp="2z07gervlk7ay">
                      {objection.answer.map(line => <p key={line} data-id="element-77" data-mp="10gaqiy22o4gm">{line}</p>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}